export const firebaseConfig = {
  apiKey: "AIzaSyCSpAHIweIjCadvRfBg5ErXYj-EJPMjj7I",
  authDomain: "trinity-matrix.firebaseapp.com",
  projectId: "trinity-matrix",
  storageBucket: "trinity-matrix.appspot.com",
  messagingSenderId: "638807085059",
  appId: "1:638807085059:web:dff3fc2283e72ba9a27e36"
};